export const MOBILE_BTN_SIZE = 48;
export const MOBILE_EDGE_GAP = 12;
export const MOBILE_RING_RADIUS = 78;
export const MOBILE_HALF_RING_SPAN = 120;

export function clampMobileAnchor(x: number, y: number) {
  const half = MOBILE_BTN_SIZE / 2;
  return {
    x: Math.min(Math.max(x, half + MOBILE_EDGE_GAP), window.innerWidth - half - MOBILE_EDGE_GAP),
    y: Math.min(Math.max(y, half + MOBILE_EDGE_GAP), window.innerHeight - half - MOBILE_EDGE_GAP),
  };
}

export function normalizeAngleDiff(diff: number) {
  let next = diff;
  while (next > 180) next -= 360;
  while (next < -180) next += 360;
  return next;
}
